module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advice-15f5e1280a8d85ed6e4212455923a67a.jpg";